import { createMuiTheme } from '@material-ui/core/styles';
import createBreakpoints from '@material-ui/core/styles/createBreakpoints';
import * as color from 'Material-UI/colors';
const breakpoints = createBreakpoints({});
declare module '@material-ui/core/styles/createMuiTheme' {
  interface Theme {
    color: {
      [key: string]: React.CSSProperties['color'];
    };
  }
  interface ThemeOptions {
    color: {
      [key: string]: React.CSSProperties['color'];
    };
  }
}

type RtlType = 'ltr' | 'rtl' | undefined;

const MuiTheme: any = (rtl: RtlType) =>
  createMuiTheme({
    direction: rtl,
    color,
    palette: {
      primary: {
        main: '#00194D',
      },
      secondary: {
        main: '#0075C9',
      },
    },

    typography: {
      fontFamily: rtl === 'rtl' ? 'Almarai' : 'Roboto',
      h1: {
        fontSize: '36px',
        color: color.sanlamIndigo,
        fontWeight: 'bold',
        marginBottom: '37px',
      },
      h2: {
        fontSize: '28px',
        color: color.sanlamIndigo,
        fontWeight: 'bold',
        marginBottom: '12px',
      },
      h3: {
        fontSize: '24px',
        color: color.sanlamIndigo,
        fontWeight: 'bold',
        marginBottom: '12px',
      },
      h4: {
        fontSize: '18px',
        color: color.sanlamIndigo,
        fontWeight: 'bold',
        marginBottom: '12px',
      },
      h5: {
        fontSize: '16px',
        color: color.sanlamIndigo,
        fontWeight: 'bold',
        marginBottom: '12px',
      },
      h6: {
        fontSize: '14px',
        color: color.sanlamIndigo,
        fontWeight: 300,
        marginBottom: '12px',
      },
      body1: {
        fontSize: '14px',
        color: color.sanlamIndigo,
        fontWeight: 300,
        lineHeight: '24px',
      },
      button: {
        width: '100%',
        boxShadow: 'none !important',
        fontSize: '14px !important',
        textTransform: 'none',
        fontWeight: 500,
      },
    },

    overrides: {
      MuiFormControlLabel: {
        label: {
          fontSize: '12px',
          lineHeight: '18px',
          color: `${color.sanlamIndigo}`,
          fontWeight: 300,
        },
      },
      MuiFormLabel: {
        root: {
          fontSize: '14px',
          lineHeight: '18px',
          color: '#1C305D',
          fontWeight: 400,
          fontFamily: 'Roboto',
        },
      },
      MuiOutlinedInput: {
        input: {
          padding: '12px',
          color: '#1C305D',
          fontWeight: 400,
          fontSize: '14px',
        },
      },
      MuiTextField: {
        root: {
          '&.MuiTextField-root .MuiOutlinedInput-root': {
            color: '#C3C9CD',
          },
          '&.MuiTextField-root .MuiInputBase-root .MuiInputAdornment-positionEnd .MuiButtonBase-root': {
            padding: '0',
            color: '#C3C9CD',
          },
          '&.MuiFormControl-root .MuiInputBase-root .MuiInputAdornment-positionStart': {
            width: '20px',
            height: '20px',
          },
        },
      },

      MuiInputLabel: {
        root: {
          '&.MuiInputLabel-outlined': {
            transform: 'translate(16px, 11px) scale(1)',
          },
        },
      },
      MuiCheckbox: {
        root: {
          '&.Mui-checked': {
            color: '#32C284 !important',
          },
        },
      },
      MuiIconButton: {
        root: {
          '&.Mui-checked': {
            color: '#32C284 !important',
          },
          '&.MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track': {
            backgroundColor: '#32C284 !important',
          },
        },
      },
      MuiAccordionSummary: {
        expandIcon: {
          [breakpoints.down('xs')]: {
            position: 'absolute',
            right: '8px',
            top: '5px',
          },
        },
      },
    },
  });

export default MuiTheme;
